import {
  getAuth,
  signInWithCustomToken,
  sendPasswordResetEmail
} from 'firebase/auth'
import * as toast from 'services/context/toast'

export const firebaseSignInWithCustomToken = async (customToken: string) => {
  const auth = getAuth()
  try {
    return await signInWithCustomToken(auth, customToken)
  } catch (e) {
    console.error(e)
    return null
  }
}

export const sendEmailPasswordReset: (credentials: {
  email: string
}) => Promise<void> = async ({ email }) => {
  const auth = getAuth()
  try {
    return await sendPasswordResetEmail(auth, email)
  } catch (e) {
    toast.handler({
      content: 'Não foi possível enviar email',
      severity: 'error'
    })
    console.error(e)
  }
}
